export default __webpack_public_path__ + "static/cover-dc7847644a8da3296d066fa5acf36861.jpg";